<template>
  <el-form
    :model="addFormData"
    ref="addFormData"
    label-width="150px"
    :rules="formRule"
    class="customerInfo"
  >
    <el-row>
      <el-col :span="10">
        <el-form-item
          :label="`付款方类型${columnSeparator}`"
          prop="customerType"
        >
          <span>
            {{ customerTypeName }}
          </span>
        </el-form-item>
        <el-form-item :label="`付款方${columnSeparator}`" prop="customerId">
          <span>{{ customerName }}</span>
        </el-form-item>
        <el-form-item
          prop="completeTime"
          :label="`收款单完成时间${columnSeparator}`"
        >
          <el-date-picker
            v-model="addFormData.completeTime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            class="input-w"
            type="datetime"
            placeholder="请选择收款单完成时间"
            clearable
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="10">
        <el-form-item :label="'付款凭证' + columnSeparator" prop="attachment">
          <div class="upload">
            <UploadCommon
              fileTitle="(付款凭证)"
              :multiple="true"
              :limit="6"
              :fileList.sync="addFormData.attachment"
              :sizeType="4"
              listType="text"
              @uploadBefore="uploadBefore"
              @uploadSuccess="uploadSuccess"
              @uploadError="uploadError"
              commonUpload
              group="finance"
              code="finance_pay_agreement_pic"
            >
            </UploadCommon>
          </div>
        </el-form-item>
        <el-form-item :label="`备注${columnSeparator}`" class="alone">
          <el-input
            type="textarea"
            v-model="addFormData.remarks"
            placeholder="请输入"
            clearable
            maxlength="500"
            show-word-limit
          >
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import selectOption from '@/store/dict/selectOptionDict'

export default {
  name: 'CollectionRecordAddForm',
  data() {
    const validatePaymentAccount = (rule, value, callback) => {
      if (/[\u4e00-\u9fa5]+/.test(value)) {
        callback(new Error('客户付款账号不能输入中文'))
      } else {
        callback()
      }
    }
    return {
      formRule: {
        completeTime: [
          {
            required: true,
            min: 1,
            max: 64,
            message: '请选择收款单完成时间',
            trigger: 'blur',
          },
        ],
        attachment: [
          {
            required: true,
            message: '付款凭证不能为空',
            trigger: 'change',
          },
        ],
        paymentAccount: [
          {
            validator: validatePaymentAccount,
            trigger: 'blur',
          },
        ],
      },
      // 时间选择器限制
      pickerOptions: {
        disabledDate(time) {
          // 收款单完成时间 不能选择当前日期之后的时间【PKXW-2685】
          return time.getTime() > Date.now()
        },
      },
    }
  },
  props: {
    addFormData: {
      type: Object,
      default: () => ({}),
    },
    customerName: {
      type: String,
      default: '',
    },
  },
  watch: {
    'addFormData.attachment': {
      handler() {
        this.$refs.addFormData.validateField('attachment')
      },
      deep: true,
    },
  },
  computed: {
    // 付付款方类型名称
    customerTypeName() {
      const {
        addFormData: { customerType },
      } = this
      return selectOption.customerTypeDict[customerType]
    },
  },
  methods: {
    uploadBefore() {
      this.$emit('uploading')
    },
    uploadSuccess() {
      this.$emit('uploaded')
    },
    uploadError() {
      this.$emit('uploaded')
    },
  },
}
</script>

<style lang="scss" scoped>
.input-w {
  width: 100%;
  max-width: 204.5px;
}
.customer-name {
  float: left;
  width: 150px;
  height: 35px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-right: 1px solid #000;
  margin: 0;
}
.contact-tel {
  float: left;
  color: #8492a6;
  font-size: 13px;
  margin: 0;
  padding-left: 10px;
}
  .guide{
    display: inline-block;
    margin-left: 10px;
    cursor: pointer;
  }
</style>
